import React from "react";
import { ShieldAlert, Mail } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const absUrl = (p) => (p && !/^https?:/i.test(p) ? `${BACKEND_URL}${p}` : p);
const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

/**
 * Rendu en direct de la page « Accès refusé » à partir d'un objet `settings`.
 * Utilisé comme preview live dans le backoffice — n'effectue aucune requête API.
 */
export default function AccessDeniedPreview({ settings, sampleIp = "192.0.2.42" }) {
  const bgPath = settings.denied_bg_image_path || settings.bg_image_path;
  const bgStyle = bgPath
    ? {
        backgroundImage: `linear-gradient(180deg, hsla(0,0%,100%,0.86) 0%, hsla(0,0%,100%,0.96) 100%), url(${absUrl(bgPath)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : { background: "var(--background, hsl(0 0% 100%))" };

  return (
    <div
      className="border border-border rounded-md overflow-hidden"
      style={{ minHeight: 380 }}
      data-testid="denied-preview"
    >
      <div className="flex items-center justify-center px-6 py-10" style={bgStyle}>
        <div className="max-w-sm w-full text-center">
          {settings.site_logo_path ? (
            <img
              src={absUrl(settings.site_logo_path)}
              alt={settings.site_title || ""}
              className="h-12 mx-auto mb-4 object-contain"
            />
          ) : (
            <div
              className="inline-flex h-12 w-12 items-center justify-center rounded-sm text-white mb-4"
              style={{ backgroundColor: settings.brand_color || "#002FA7" }}
            >
              <ShieldAlert className="h-6 w-6" />
            </div>
          )}
          <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-1">
            403 — {settings.denied_title || "Accès refusé"}
          </p>
          <h2 className="text-xl sm:text-2xl font-black tracking-tight leading-tight mb-2">
            {settings.denied_subtitle || "Votre adresse IP n'est pas autorisée"}
          </h2>
          <p className="text-xs text-muted-foreground mb-1 whitespace-pre-wrap">
            {settings.denied_message || ""}
          </p>
          {settings.denied_show_ip && (
            <p className="text-[11px] text-muted-foreground mt-2">
              Votre IP : <span className="font-mono text-foreground">{sampleIp}</span>
            </p>
          )}
          {settings.denied_contact && (
            <p className="mt-3">
              {isEmail(settings.denied_contact) ? (
                <span
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs font-medium text-white"
                  style={{ backgroundColor: settings.brand_color || "#002FA7" }}
                >
                  <Mail className="h-3 w-3" /> Contacter l&apos;administrateur
                </span>
              ) : (
                <strong className="text-xs">{settings.denied_contact}</strong>
              )}
            </p>
          )}
          <span className="mt-4 inline-block text-[11px] text-muted-foreground border border-border rounded-sm px-3 py-1">
            Connexion administrateur
          </span>
        </div>
      </div>
      <div className="bg-muted/50 px-3 py-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground border-t border-border">
        Aperçu — IP fictive 192.0.2.42
      </div>
    </div>
  );
}
